<template> 
  <course-form :is-edit='false'></course-form>
</template>
<script>
  import CourseForm from './courseForm'
  export default {
    name: 'courseAdd',
    components: { CourseForm }
  }
</script>
<style>
</style>


